import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);

    const [leavedet, setLeaveDetail] = useState({
            status: "",
            remarks: "",
            leave_type_id:"",
            leave_id:"",
			emp_id:"",
            diff_days:"",
			available_leave:"",
            leave_available:"",
            sick_leave_available:"",

           
        })
	

        const handelInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setLeaveDetail({ ...leavedet, [name]: value });
        }

	// convert an "HH:MM" (or decimal hour) value into total minutes for comparison
	const otToMinutes = (t) => {
		if (t === undefined || t === null || t === "") return 0;
		const str = String(t).trim();
		if (str.indexOf(":") !== -1) {
			const parts = str.split(":");
			return (parseInt(parts[0], 10) || 0) * 60 + (parseInt(parts[1], 10) || 0);
		}
		return Math.round((parseFloat(str) || 0) * 60);
	}






const handleEditLeaveStatus = (e) => {
    e.preventDefault();

	// overtime hour can never be increased beyond the applied Overtime Hour
	if (otToMinutes(leavedet.overtime_hour) > otToMinutes(leavedet.ot_hours)) {
		toast.error("Overtime hour cannot be more than the overtime hour (" + leavedet.ot_hours + ").", {
			position: "bottom-right",
			autoClose: 5000,
			theme: "colored",
		});
		return;
	}

    const token = localStorage.getItem("authToken");

    axios.post(
        API_BASE_URL + '/hr_overtime_update',
        {
            status: leavedet.status,
            remarks: leavedet.remarks,
            overtime_ids: param,
            overtime_hour: leavedet.overtime_hour,
            overtime_amt: leavedet.ot_amt   // correct value
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json"
            }
        }
    )
    .then(response => {

        const status = response.data.status;

        if (status === 'success') {
            toast.success(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                theme: "colored",
            });

            setTimeout(() => {
                history.push("Hrot");
            }, 3000);

        } else {

            toast.error(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                theme: "colored",
            });

        }

    })
    .catch(error => {

        toast.error(
            error.response?.data?.message || "Update failed",
            {
                position: "bottom-right",
                autoClose: 5000,
                theme: "colored",
            }
        );

    });
};


	useEffect(() => {
  axios
    .get(API_BASE_URL + "/hr_ot_detail_data/" + param, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
    .then(res => {
      if (res.data && res.data.leave_detail) {
        setLeaveDetail(prev => ({
          ...prev,
          ...res.data.leave_detail,
        }));
      }
    })
    .catch(err => console.log(err));
}, [param]);


useEffect(() => {
	if (leavedet.overtime_hour && leavedet.per_hour) {
		const parts = leavedet.overtime_hour.split(':');
		let finalOt = 0;
		if (parts.length === 2) {
			const hours = parseFloat(parts[0]) || 0;
			const minutes = parseFloat(parts[1]) || 0;
			finalOt = hours + (minutes / 60);
		} else {
			finalOt = parseFloat(leavedet.overtime_hour) || 0;
		}
		const otAmount = finalOt * parseFloat(leavedet.per_hour);
		setLeaveDetail(prev => ({
			...prev,
			final_ot: finalOt.toFixed(2),
			ot_amt: otAmount.toFixed(2),
		}));
	}
}, [leavedet.overtime_hour, leavedet.per_hour]);

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-4">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4 col-lg-6">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title"> HR Overtime Detail</h5>
                                    </div>
                                    <div className="card-body">
                                      
                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                                    <tbody>
                                                        <tr>
                                                        <th>Employee</th>
                                                        <td>{leavedet.full_name}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Employee ID</th>
                                                        <td>{leavedet.emp}</td>
                                                        </tr>
                                                        <tr>
                                                        <th> Overtime Date</th>
                                                        <td>{leavedet.overtime_date}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Overtime Hour</th>
                                                        <td>{leavedet.ot_hours}</td>
                                                        </tr>
                                                         <tr>
  <th>Shift Time</th>
  <td>
    <strong>{leavedet.shift_name}</strong><br/>
    <small className="text-success">{leavedet.shift_time}</small>
  </td>
</tr>

<tr>
  <th>Punch In & Out</th>
  <td>{leavedet.log_in} - {leavedet.log_out}</td>
</tr>
                                                        <tr>
                                                            
                                                        <th>Calculated Overtime Hour</th>
                                                        <td>{leavedet.final_ot}</td>
                                                        </tr>
														<tr>
														<th>Applied On</th>
                                                        <td>{leavedet.applied_on}</td>
                                                        </tr>
                                        <tr>
														<th>Shift Hour</th>
                                                        <td>{leavedet.shift_hr}</td>
                                                        </tr>
                                                        <tr>
														<th>Net Take</th>
                                                        <td>{leavedet.net_take}</td>
                                                        </tr>
                                        <tr>
														<th>Actual Amount</th>
                                                        <td>{leavedet.act_amout}</td>
                                                        </tr>
                                        
                                                         <tr>
														<th>Per Hour</th>
                                                        <td>{leavedet.per_hour}</td>
                                                        </tr>

                                                         <tr>
														<th>OT Amount</th>
                                                        <td>{leavedet.ot_amt}</td>
                                                        </tr>
                                                         <tr>
														<th>Hod Remarks</th>
                                                        <td>{leavedet.dept_remarks}</td>
                                                        </tr>
                                                    </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5">
                                <form className="card" onSubmit={handleEditLeaveStatus}>
                                    <div className="card-body">
                                        <h3 className="card-title">Update Status</h3>
                                        <div className="row">
                                         
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Status </label>
                                                    <select className="form-control show-tick required-input" name="status" value={leavedet.status} onChange={handelInput}>
                                                    <option value="" >select Status</option>
                                                    <option value="2" >Approved</option>
                                                    <option value="3" >Rejected</option>
                                                    </select>
                                                </div>
                                            </div>

                                             <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Overtime Hour <small className="text-muted">(max {leavedet.ot_hours}, can only be reduced)</small></label>
                                                    <input type ='text' className="form-control" name="overtime_hour" placeholder="HH:MM" value={leavedet.overtime_hour} onChange={handelInput}></input>
                                                </div>
                                            </div>
                                             <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Overtime Amount</label>
                                                    <input type ='text' className="form-control" name="overtime_amt" readOnly value={leavedet.ot_amt} onChange={handelInput}></input>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group mb-0">
                                                    <label className="form-label">Remarks</label>
                                                    <textarea rows={5} className="form-control required-input" id="textarea" name="remarks" value={leavedet.remarks}  onChange={handelInput} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    
                      

                                    <div className="card-footer text-left">

                                    <input type="hidden" name="overtime_id" value={leavedet.overtime_id} />
                                    <input type="hidden" name="emp_id" value={leavedet.employee_id} />
                                     <input type="hidden" name="overtime_hour" value={leavedet.overtime_hour} />

                                  

           
                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </div>

                                    {/* {leavedet.status==1 && (

                                   
                                    )} */}
                                </form>
                           
                            </div>




                        </div>
                    </div>

                    </div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);